import { useStaticQuery, useStaticMutation } from '../../../helpers/useStaticData';
import { getReservations } from '../../../helpers/data';

export const useGetReservQuery = () => useStaticQuery(() => getReservations());

export const useReservationMutation = () => useStaticMutation();

export const useUpdateReservMutation = () => useStaticMutation();

export const useDeleteReservMutation = () => useStaticMutation();
